<template>
  <div class="package-list-base">
    <h1>占いTVお試しパック</h1>
    <span class="head-caption">月額登録して読める「占いTV」の占いを、ちょっとだけ試してみたい方に！</span>
    <p class="attention" v-if="true">※サブスクリプションにお申込み済みの方は、サブスクリプション内で占えるものと同一のメニューになります。購入せず、ログインして画面左側「さがす」から検索してご覧ください。</p>
    <div class="item-list-base">
      <article class="list-item"
           v-for="(item, idx) in itemList" :key="idx"
           @click="onListItemClick(item.id)"
      >
        <span class="img-wrap"><img :src="item.package_image" :alt="item.package_name" @error="onImgLoadError"></span>
        <h2>{{item.package_name}}</h2>
        <p v-html="item.caption"></p>
        <span class="price" v-if="item.price_taxin != null">￥{{item.price_taxin | priceFormat}}<span class="tax-in">（税込）</span></span>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageList',
  props: {
    itemListReceive: {
      type: Array,
      default(){
        return []
      }
    }
  },
  computed: {
    itemList() {
      return this.itemListReceive
    }
  },
  methods: {
    onImgLoadError(e) {
      e.target.parentElement.classList.add('noimage')
    },
    onListItemClick(tgtid) {
      location.href = `/package/${tgtid}/detail`
    }
  },
  filters: {
    priceFormat(val) {
      return val.toLocaleString()
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';
.package-list-base {
  width: 100%;
  color: black;
  padding: 20px 0 30px;
  @include mq('w580'){
    padding: 30px 20px;
  }

  h1 {
    padding: 0 20px;
    font-size: 18px;
    line-height: 27px;
    font-weight: bold;
    margin: 0 0 11px;
  }

  .head-caption {
    padding: 0 20px 5px;
    font-size: 13px;
    line-height: 21px;
    display: block;
  }

  .attention {
    padding: 0 20px;
    margin: 0 0 20px;
    font-size: 11px;
    color: $col_base_black;
  }

  .item-list-base {
    width: 100%;
    padding: 0 12px;
    .list-item {
      $imageW: 152px;
      min-height: $imageW;
      padding: 16px 13px 16px $imageW + 8px;
      position: relative;
      border: 1px solid #ededed;
      border-radius: 5px;
      overflow: hidden;
      margin-bottom: 8px;
      cursor: pointer;
      h2 {
        margin: 0 0 8px;
        font-size: 12px;
        line-height: 16px;
        font-weight: bold;
      }
      p {
        font-size: 12px;
        line-height: 15px;
        margin: 0 0 10px;
      }
      .price {
        display: block;
        width: 100%;
        font-size: 12px;
        font-weight: bold;
        color: #ed1e78;
        line-height: 1;
        .tax-in {
          transform-origin: left bottom;
          transform: scale(0.72, 0.72) translate(-5px, -1px);
          color: #676767;
          display: inline-block;
          font-weight: normal;
        }
      }

      .img-wrap {
        width: $imageW;
        height: $imageW;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $col_lite_gradient;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.noimage {
          & > img {
            visibility: hidden;
          }
          &::after {
            content: 'NO IMAGE';
            text-align: center;
            position: absolute;
            line-height: 1;
            font-size: 11px;
            color: $col_temp_key1;
            background: $col_lite_gradient;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Package/PackageList.vue